import React from "react";

export default function Video({ fill, width, height }) {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33333 0.666504C1.8471 0.666504 1.38079 0.859658 1.03697 1.20347C0.693154 1.54729 0.5 2.01361 0.5 2.49984V7.49984C0.5 7.98607 0.693154 8.45238 1.03697 8.7962C1.38079 9.14002 1.8471 9.33317 2.33333 9.33317H8C8.48623 9.33317 8.95255 9.14002 9.29636 8.7962C9.64018 8.45238 9.83333 7.98607 9.83333 7.49984V6.43717L12.1127 8.46717C12.6493 8.94517 13.5 8.56384 13.5 7.8445V1.90984C13.5 1.18984 12.6493 0.809171 12.1127 1.28717L9.83333 3.31717V2.49984C9.83333 2.01361 9.64018 1.54729 9.29636 1.20347C8.95255 0.859658 8.48623 0.666504 8 0.666504H2.33333Z"
        fill={fill}
      />
    </svg>
  );
}
